import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { UserNoalOrgan } from "../../users/user-management-models/user-noal-organ";
import { Observable } from "rxjs/Observable";
import { NewDiscountFormState } from "../discount-models/NewDiscountFormState";

@Component({
  selector: "new-discount-form-select-event",
  templateUrl: "./new-discount-form-select-event.component.html",
  styleUrls: ["./new-discount-form-select-event.component.scss"],
})
export class NewDiscountFormSelectEventComponent implements OnInit, OnDestroy {
  @Input("newDiscountFormState")
  public newDiscountFormState$: Observable<NewDiscountFormState>;
  @Output("updateDiscountEvent")
  public updateDiscountEvent: EventEmitter<NewDiscountFormState> = new EventEmitter<NewDiscountFormState>();
  constructor() {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  public updateSelectedOrgans($event: any) {}
}



// WEBPACK FOOTER //
// ./src/app/admin/discounts/new-discount-form-select-event/new-discount-form-select-event.component.ts